// removed by extract-text-webpack-plugin
module.exports = {"content":"ReasonsView__content___27JQC"};